var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "step2-wrapper"
  }, [_c('div', {
    staticClass: "step-details"
  }, [_c('div', {
    staticClass: "step2-left"
  }, [_c('details-field-group', {
    attrs: {
      "id": _vm.uuid,
      "label": "Library Details",
      "is-bio-styling": true,
      "collapsed": false
    }
  }, [_c('BioMaterialView', {
    attrs: {
      "material-type": _vm.materialType,
      "uuid": _vm.uuid,
      "hide-title": true,
      "group-nid": _vm.groupNid,
      "omit-fields": _vm.editFields,
      "show-add-to-library": false,
      "bio-material-data": null,
      "show-library-style": true
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "step2-right"
  }, [_c('radio-set', {
    attrs: {
      "name": "BioMaterialStepChooser",
      "options": _vm.getOptions,
      "label-name": "",
      "id": "bio-material-step-chooser"
    },
    on: {
      "radio-selection": function ($event) {
        return _vm.selected($event);
      }
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "buttontray"
  }, [_c('v-button', {
    class: _vm.disableButton,
    attrs: {
      "type": "submit"
    },
    on: {
      "click": _vm.clickContinue
    }
  }, [_vm._v("\n      Continue\n    ")])], 1)]);

}
var staticRenderFns = []

export { render, staticRenderFns }